<template>
    <div v-if="clinics && onlineClinics.length > 0">
      <div>
        <div v-for="clinic in clinics" :key="clinic.id" class="online-clinics">
            <ResultsOnlineClinic :clinic="clinic" />
        </div>
        <ResultsOnlineClinicToggleButton :showMore="showMore" v-on:toggle="onToggle" />
      </div>
      <hp5-spacing-vertical xs="lg" xm="lg" md="lg" lg="lg" xl="lg"></hp5-spacing-vertical>
    </div>
</template>
<script setup>

    const { onlineClinics } = useFCPModel()
    const showMore = ref(false)
    const clinics = computed(() => !showMore.value && onlineClinics.value?.length > 1 ? [onlineClinics.value[0]] : onlineClinics.value )

    const onToggle = (event) => {
        showMore.value = event
    }
   
</script>
  